import { fork, takeEvery, all } from 'redux-saga/effects';
import {
  ManagerAccountApi,
  ManagerAccountControllerDtoMyNameChangeRequest,
  ManagerAccountControllerDtoMyPasswordChangeRequest,
  ManagerAccountControllerDtoMyRemoveTwoFactorRequest,
} from '../../models/src';
import config from '../../../config/config';
import BaseResponse from '../../models/src/model/BaseResponse';
import {
  MY_INFO_REQUEST,
  MY_NAME_CHANGE,
  MY_PASSWORD_CHANGE,
  MY_TWOFACTOR_REMOVE,
} from '../../constants/setting/myInfoConstants';
import pwdHashAPI from '../../../api/ui/pwdHashAPI';
import ManagerAccountControllerDtoMyInfoResponse
  from '../../models/src/model/ManagerAccountControllerDtoMyInfoResponse';
import ManagerAccountControllerDtoMyNameChangeResponse
  from '../../models/src/model/ManagerAccountControllerDtoMyNameChangeResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new ManagerAccountApi(config.API_CLIENT);

// function getUrlVars() {
//   const vars = {};
//   const parts = window.location.href.replace(
//     /[?&]+([^=&]+)=([^&]*)/gi,
//     function (m, key, value) {
//       // eslint-disable-line
//       vars[key] = value;
//     },
//   );
//   return vars;
// }

//= ====================================
//  WATCHERS
//-------------------------------------
function* myInfoRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const result = yield api.apiManagerAccountMyInfoPost(() => {});
    const data = api.apiClient.deserialize(result, ManagerAccountControllerDtoMyInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* myPasswordChangeSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerAccountControllerDtoMyPasswordChangeRequest();
    requestData.password = pwdHashAPI.toSha512(payload.password);
    requestData.newPassword = pwdHashAPI.toSha512(payload.newPassword);
    requestData.twofaNo = payload.twofaNo;
    const result = yield api.apiManagerAccountMyPasswordChangePost({ managerAccountControllerDtoMyPasswordChangeRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* myTwoFactorRemoveSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new ManagerAccountControllerDtoMyRemoveTwoFactorRequest();
    requestData.password = pwdHashAPI.toSha512(payload.password);
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerAccountMyRemoveTwofactorPost({ managerAccountControllerDtoMyRemoveTwoFactorRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* myNameChangeSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData =  new ManagerAccountControllerDtoMyNameChangeRequest();
    requestData.newName = payload.newName;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiManagerAccountMyNameChangePost({ managerAccountControllerDtoMyNameChangeRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, ManagerAccountControllerDtoMyNameChangeResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* myInfoRootSaga() {
  yield all([
    takeEvery(MY_INFO_REQUEST, myInfoRequestSaga),
    takeEvery(MY_PASSWORD_CHANGE, myPasswordChangeSaga),
    takeEvery(MY_TWOFACTOR_REMOVE, myTwoFactorRemoveSaga),
    takeEvery(MY_NAME_CHANGE, myNameChangeSaga),
  ]);
}

const myInfoSagas = [fork(myInfoRootSaga)];

export default myInfoSagas;
